import { AxiosResponse } from 'axios';
import api from '../../../services/api';
import { TenantInterface } from '@e3labs/isa-data-dictionary';
class TenantService {
  getTenant(id: any) {
    return api.get(`/tenant/${id}`);
  }

  putTenant(id: string, body: TenantInterface) {
    return api.put(`/tenant/${id}`, {
      _id: id,
      ...body
    });
  }

  putImageTenant(tenantId: any, file: any): Promise<AxiosResponse<any>> {
    const formData = new FormData();
    formData.append('picture', file);

    return api.put<any>(`tenant/${tenantId}/tenantinfo/picture`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  putImageSubsidiary(subsidiaryId: any, file: any): Promise<AxiosResponse<any>> {
    const formData = new FormData();
    formData.append('picture', file);

    return api.put<any>(`/domain/subsidiaries/${subsidiaryId}/picture`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  putPriceTableCodeSubsidiary(subsidiary): Promise<AxiosResponse<any>> {
    return api.put(`/subsidiary/${subsidiary?._id}`, {
      ...subsidiary
    });
  }

  getListShankyaConfig({ skip, limit = 10, ...rest }): Promise<AxiosResponse<any>> {
    return api.get('common/erp-config', {
      params: {
        skip,
        limit,
        ...rest
      }
    });
  }

  getListShankyaCount(filters?: any): Promise<AxiosResponse<any>> {
    return api.get('common/erp-config-count', {
      params: {
        ...filters
      }
    });
  }

  getTestConnectionTenant(tenantID: any) {
    return api.get('/tenant/health', {
      params: {
        tenantID
      }
    });
  }
}

export default new TenantService();
